import { DOMAIN } from "./../Config";
import { Toast } from 'antd-mobile';

import Token from "./token";
const axios = require("axios");

const instance = axios.create({
  baseURL: DOMAIN,
});

const request = async (uri, { method = "GET", data }) => {
  const options = {
    method,
    headers: {
      "Content-Type": "application/json",
    },
    // withCredentials: true,
    validateStatus: (status) => status >= 200 && status <= 401,
  };

  if (method === "POST") {
    options.data = JSON.stringify(data);
  }
  if (Token.getToken()) {
    // uri = uri +
    //   (uri.indexOf('?') > 0 ? '&' : '?') +
    //   `access-token=${Token.getToken()}`;
    options.headers["access-token"] = Token.getToken();
  }
  if (Token.getUUID()) {
    options.headers["uuid"] = Token.getUUID();
  }
  if (Token.getOptions()) {
    uri = uri + (uri.indexOf("?") > 0 ? "&" : "?") + Token.getOptions();
  }
  // const url = DOMAIN + uri;
  options.url = uri;
  return axios(options)
    .then(async ({ data, status, statusText, headers }) => {
      if (status === 200) {
        if (data.code === "10403" || data.code === 10403) {
          return { data: data };
        }
        if (data.data && data.data.redirect_url) {
          if (data.message) {
            Toast.info(data.message, 2);
            await new Promise((reject) => setTimeout(reject, 1000));
            window.location = data.data.redirect_url;
            return;
          }
          window.location = data.data.redirect_url;
          return;
        }
      }
      if (status !== 200) {
        if (status === 401) {
          if (data.data.redirect) window.location = data.data.redirect;
          return;
        }
        return { err: "请求失败，请重试!" };
      }
      if (headers["access-token"]) {
        Token.saveToken(headers["access-token"]);
      }
      if (data.result === "success") {
        return { data: data };
      } else {
        Token.clear();
        Toast.info(data.message || "请求失败，请重试!");
        return { err: data.message };
      }
    })
    .catch((err) => ({ err }));
};

export default request;
